import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import validationMessagesPtBR from 'vee-validate/dist/locale/pt_BR'
import validationMessagesEn from 'vee-validate/dist/locale/en'
import moment from 'moment'
import { createI18n } from './_i18n'
import { GOOGLE_ANALYTICS_ID } from 'utils/constants'
import AppServices from './services'
import GMaps from './libs/gmaps/config'
import './filters'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { omegaInstance } from 'common/omega'
import { initSCG } from '@didi/wsgsdk'
import iframeInit from 'utils/iframe'
// Polyfills for IE Support
import '@babel/polyfill'
import './plugins/vuetify'

// Application
import App from './App'

Vue.config.productionTip = false
Vue.prototype.moment = moment

const i18n = createI18n()

Vue.use(VueAnalytics, {
  id: GOOGLE_ANALYTICS_ID,
  router,
  ignoreRoutes: ['/login'],
  checkDuplicatedScript: true,
  debug: {
    enabled: false,
    trace: false,
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

Vue.use(VeeValidate, {
  events: 'change|blur|submit',
  i18nRootKey: 'validations', // customize the root path for validation messages.
  i18n,
  dictionary: {
    en: validationMessagesEn,
    pt_BR: validationMessagesPtBR
  }
})

Object.keys(AppServices).forEach(k => Vue.use(AppServices[k]))
Vue.use(GMaps)

Vue.filter('myLocale', function (value, localePath) {
  return i18n.t(`${localePath}.${value}`)
})
Sentry.init({
  Vue,
  dsn: 'https://05cd666187cc44ff99cd724657eb927b@sentry-us.didiglobal.com/77',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: `${process.env.NODE_ENV}` || 'production',
  release:
    `${process.env.VUE_APP_NAME}@${process.env.VUE_APP_VERSION}` || 'corporate-front-vue@1.19.2'
})

const getDomainList = listStr => {
  try {
    return (
      listStr?.split(',') || [
        'b2b-api.99app.com',
        'b2b-gateway-new-prod.99app.com',
        'b2b-gateway.99app.com'
      ]
    )
  } catch (e) {
    return ['b2b-api.99app.com', 'b2b-gateway-new-prod.99app.com', 'b2b-gateway.99app.com']
  }
}
const domainList = getDomainList(process.env.VUE_APP_API_DOMAIN)

/** 接入验签和挑战应答
 * 工程接入人：jingqinyang@didiglobal.com
 * SDK提供方：kingrainwangyu@didiglobal.com
 * SDK版本：1.4.1
 */
initSCG({
  // 验签涉及的初始化字段 详情查看[dd05接入文档](https://cooper.didichuxing.com/docs/document/2200553116152)
  env: 'ame', // 国际化固定写ame
  bizId: 'cea6ce3bb31dd7c28b6f1a880f4c339b', // 需要找fengweihuaer@didiglobal.com生成
  appVer: `${process.env.VUE_APP_NAME}@${process.env.VUE_APP_VERSION}`, // 工程的appversion
  os: '4', // H5填4

  // 挑战应答涉及的初始化字段
  omega: omegaInstance, // 非必传 如使用omega则传入omega实例
  domainList // 挑战应答开关 不填域名为关闭 反之开启 域名列表  由业务方自定义添加 不加协议
})

iframeInit(store)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
